import CookieManager, { CookieAttributes } from "js-cookie";
import { injectable } from "tsyringe";
import { Log } from "src/libs/log";
import { autoBind } from "src/shared/decorators/autobind";

@injectable()
export class CookieStorageService {
    @autoBind
    setCookie(
        key: string,
        value: any,
        cookieOptions: Partial<CookieAttributes> = {}
    ): void {
        let stringfiedValue = value;
        if (typeof value === "object") {
            stringfiedValue = JSON.stringify(value);
        }
        if (typeof value === "number") {
            stringfiedValue = value.toString();
        }
        if (typeof value === "boolean") {
            stringfiedValue = `${value}`;
        }
        if (typeof value === "function") {
            stringfiedValue = value.toString();
        }
        if (typeof value === "symbol") {
            stringfiedValue = value.toString();
        }
        Log.info(
            `Storing cookie "${key}" with value: "${stringfiedValue}" and attributes "${JSON.stringify(
                cookieOptions
            )}"`
        );
        CookieManager.set(key, stringfiedValue, {
            path: "/",
            ...cookieOptions,
        });
    }

    @autoBind
    getCookie<T>(key: string): T | null {
        const value = CookieManager.get(key);

        if (!value) {
            return null;
        }

        try {
            return JSON.parse(value);
            // eslint-disable-next-line no-empty
        } catch {}
        if (!isNaN(Number.parseFloat(value))) {
            return Number.parseFloat(value) as unknown as T;
        }
        return value as unknown as T;
    }

    @autoBind
    removeCookie(key: string): void {
        CookieManager.remove(key);
    }
}
